import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartShiftMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StartShiftMutation = { __typename?: 'Mutation', employeeStartShift: { __typename?: 'Shift', id: string, startTime: any } };

export type GetCurrentShiftForLoginQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentShiftForLoginQuery = { __typename?: 'Query', getCurrentShift?: { __typename?: 'Shift', id: string, startTime: any, endTime?: any | null } | null };


export const StartShiftDocument = gql`
    mutation StartShift {
  employeeStartShift {
    id
    startTime
  }
}
    `;
export type StartShiftMutationFn = Apollo.MutationFunction<StartShiftMutation, StartShiftMutationVariables>;

/**
 * __useStartShiftMutation__
 *
 * To run a mutation, you first call `useStartShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startShiftMutation, { data, loading, error }] = useStartShiftMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartShiftMutation(baseOptions?: Apollo.MutationHookOptions<StartShiftMutation, StartShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartShiftMutation, StartShiftMutationVariables>(StartShiftDocument, options);
      }
export type StartShiftMutationHookResult = ReturnType<typeof useStartShiftMutation>;
export type StartShiftMutationResult = Apollo.MutationResult<StartShiftMutation>;
export type StartShiftMutationOptions = Apollo.BaseMutationOptions<StartShiftMutation, StartShiftMutationVariables>;
export const GetCurrentShiftForLoginDocument = gql`
    query GetCurrentShiftForLogin {
  getCurrentShift {
    id
    startTime
    endTime
  }
}
    `;

/**
 * __useGetCurrentShiftForLoginQuery__
 *
 * To run a query within a React component, call `useGetCurrentShiftForLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentShiftForLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentShiftForLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentShiftForLoginQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>(GetCurrentShiftForLoginDocument, options);
      }
export function useGetCurrentShiftForLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>(GetCurrentShiftForLoginDocument, options);
        }
export function useGetCurrentShiftForLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>(GetCurrentShiftForLoginDocument, options);
        }
export type GetCurrentShiftForLoginQueryHookResult = ReturnType<typeof useGetCurrentShiftForLoginQuery>;
export type GetCurrentShiftForLoginLazyQueryHookResult = ReturnType<typeof useGetCurrentShiftForLoginLazyQuery>;
export type GetCurrentShiftForLoginSuspenseQueryHookResult = ReturnType<typeof useGetCurrentShiftForLoginSuspenseQuery>;
export type GetCurrentShiftForLoginQueryResult = Apollo.QueryResult<GetCurrentShiftForLoginQuery, GetCurrentShiftForLoginQueryVariables>;